'use client';

import React from 'react';
import * as S from './styles';
import Text from '@/components/atoms/Text';
import Badge from '@/components/atoms/Badge';
import { ProdutoHomeProps } from '../..';
import Link from 'next/link';
import Imagem from '@/components/atoms/Imagem';
import { useTheme } from 'styled-components';

export default function ProdutoHomeDesktop(props: ProdutoHomeProps) {
  const {
    nome,
    imagem,
    slug,
    etiqueta,
    assinatura,
    categoria,
    style = {},
  } = props;

  const theme = useTheme();

  return (
    <Link
      style={style}
      href={`/${assinatura ? 'assinatura' : 'produto'}/${slug}`}
      passHref
    >
      <S.Container>
        <S.ImageContainer>
          <Imagem
            descricaoImagem="pedidoAvulso"
            priority={true}
            imagemUrl={imagem}
            style={{
              borderRadius: theme.radius[4],
            }}
            propsNextImage={{
              unoptimized: true,
            }}
          />
        </S.ImageContainer>
        <S.ProdutoInfo>
          {categoria ? (
            <Text
              $size={2}
              $color="neutral"
              $weight="regular"
              $align="left"
              $highContrast={true}
              $text={categoria?.nome}
            />
          ) : null}
          <Text
            $size={2}
            $color="neutral"
            $weight="bold"
            $align="left"
            $highContrast={true}
            $text={nome}
          />
        </S.ProdutoInfo>
        {etiqueta ? (
          <S.EtiquetaContainer>
            <Badge
              $size={1}
              $rounded={false}
              $variant="solid"
              $color={etiqueta.corFundo}
              $highContrast={false}
              $text={etiqueta.descricao}
              $textColor={etiqueta.corTexto}
            />
          </S.EtiquetaContainer>
        ) : null}
      </S.Container>
    </Link>
  );
}
